export default __webpack_public_path__ + "static/media/INVENTORY A.e6e1f177.png";